/**
 * <s-sticky-buy> — mobile buy bar that appears once the main add-to-cart button scrolls
 * out of view. It hides again when that button returns, when another full buy area
 * marked [data-sticky-buy-hide] is on screen (so two identical buttons never stack),
 * or when the footer is reached, so it never covers the footer's contact and legal links.
 */
class SStickyBuy extends HTMLElement {
  #observer;
  #passedMainButton = false;
  #blockers = new Set();

  connectedCallback() {
    const target = document.querySelector('[data-main-add]');
    if (!target || !('IntersectionObserver' in window)) return;

    const blockers = [
      ...document.querySelectorAll('[data-sticky-buy-hide]'),
      document.querySelector('footer'),
    ].filter(Boolean);

    this.#observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === target) {
          this.#passedMainButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        } else if (entry.isIntersecting) {
          this.#blockers.add(entry.target);
        } else {
          this.#blockers.delete(entry.target);
        }
      }
      this.#update();
    });

    this.inert = true;
    this.#observer.observe(target);
    blockers.forEach((el) => this.#observer.observe(el));
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #update() {
    const visible = this.#passedMainButton && this.#blockers.size === 0;
    this.toggleAttribute('data-visible', visible);
    this.inert = !visible;
  }
}

if (!customElements.get('s-sticky-buy')) customElements.define('s-sticky-buy', SStickyBuy);
